<template>
  <div id="form" class="content">
    <h1>
      Liste de {{ $route.params.user }}
      <router-link to="/"  class="ico" title="Retour">
        <span class="fa fa-backward"></span>
      </router-link>
      <span class="fa fa-floppy-o ico" v-on:click="save"></span>      
    </h1>

    <p>Modifiez l'ordre des cadeaux en les glissant à votre convenance.<br/> Puis cliquez sur la disquette pour sauvegarder</p>

    <Draggable v-model="wishes" tag="ol" @start="drag=true" @end="drag=false" @change="change" class="sortable">
      <li v-for="w in wishes" :key="w.id" class="box">
        {{w.label}}
      </li>
    </Draggable>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  components: {Draggable},
  methods: {
    change(){
      this.changed = true
    },
    save(){
      if(this.changed === true){
        let base = 10
        let idx = 1
        let list = []
        this.wishes.forEach(wish => {
          list.push({
            id: wish.id,
            priority: base * idx
          })
          idx++
        })
        let impersonate = undefined
        if(this.$route.params.owner !== undefined){
          impersonate = this.$route.params.owner
        }
        this.$api.priorityChange(list, impersonate, this, function(component, returnUser){
          component.$router.push({ path: "/list/" + returnUser })
        })
      }else{
        let returnUser = this.$oauth.getCurrentUser()
        if(this.$route.params.owner !== undefined){
          returnUser = this.$route.params.owner
        }
        this.$router.push({ path: "/list/" + returnUser })
      }
    },
    loadWishes () {
      let user = this.$oauth.getCurrentUser()
      if(this.$route.params.owner !== undefined){
        user = this.$route.params.owner
      }
      this.$api.wishlist(user,this, function(component, data) {
        data.sort((a, b) => (a.priority > b.priority) ? 1 : -1);
        component.wishes = data
      })
    }
  },
  mounted () {
    this.loadWishes()
  },
  data () {
    return {
      wishes: [],
      changed: false
    }
  }
}
</script>

<style scoped>
  .box {
    border: thin solid black;
    margin: 10px;
  }

  .ico {
    text-decoration: none;
  }

  h1 {
    font-family: Trebuchet MS, Verdana, Arial, Sans-serif;
    font-size: 1.8em;
    margin: 10px;
    text-align: center;
  }

  .sortable {
    list-style: decimal-leading-zero;
  }
</style>